import { Grid } from '@mui/material';
import {
  Science as ScienceIcon,
  Today as TodayIcon,
  DateRange as DateRangeIcon,
  CalendarMonth as CalendarMonthIcon,
  PlayCircle as PlayCircleIcon,
  Error as ErrorIcon,
} from '@mui/icons-material';
import { SummaryCard } from './SummaryCard';
import type { DashboardSummary } from '@/services/api/dashboardService';

interface SummaryCardsProps {
  data: DashboardSummary;
}

export function SummaryCards({ data }: SummaryCardsProps) {
  const cards = [
    {
      title: 'Total Tests',
      value: data.totalTests,
      icon: <ScienceIcon />,
      color: '#1976d2',
    },
    {
      title: 'Tests Today',
      value: data.testsToday,
      icon: <TodayIcon />,
      color: '#2e7d32',
    },
    {
      title: 'Tests This Week',
      value: data.testsThisWeek,
      icon: <DateRangeIcon />,
      color: '#ed6c02',
    },
    {
      title: 'Tests This Month',
      value: data.testsThisMonth,
      icon: <CalendarMonthIcon />,
      color: '#9c27b0',
    },
    {
      title: 'Active Tests',
      value: data.activeTests,
      icon: <PlayCircleIcon />,
      color: data.activeTests > 0 ? '#0288d1' : '#757575',
      pulseAnimation: data.activeTests > 0,
    },
    {
      title: 'Failed (30 days)',
      value: data.failedTestsLast30Days,
      icon: <ErrorIcon />,
      color: data.failedTestsLast30Days > 0 ? '#d32f2f' : '#757575',
    },
  ];

  return (
    <Grid container spacing={3}>
      {cards.map((card) => (
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2 }} key={card.title}>
          <SummaryCard
            title={card.title}
            value={card.value}
            icon={card.icon}
            color={card.color}
            pulseAnimation={card.pulseAnimation}
          />
        </Grid>
      ))}
    </Grid>
  );
}
